
import { isValidPhoneNumber } from 'react-phone-number-input';
import { useApartmentListForCourse } from '../../assets/api/useAdminApi';
import { PhoneInputFormField } from '../../shared/components/formfields/PhoneInputFormField';
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import CheckIcon from "@mui/icons-material/Check";
import { Formik, Field, Form } from "formik";
import * as yup from "yup";
import { Box, Button, Grid2, Typography } from '@mui/material';
import { TextFormField } from '../../shared/components/formfields/TextFormField';
import { AutoCompleteField } from '../../shared/components/formfields/AutoCompleteField';
import { useState } from 'react';
import { useToaster } from '../../shared/utils/ToasterProvider';
import { useMutation } from '@tanstack/react-query';
import api from '../../assets/nodeApi/axiosInstance';
import CustomDivider from '../../shared/utils/CustomDivider';
import { Grid_Gap } from '../../shared/constants';

const RegisterStudent = () => {
    const [isOtpSent, setIsOtpSent] = useState(false)
    const { data: apartmentList, isLoading: isLoadingApartmentList } = useApartmentListForCourse();
    const ApartmentOptionsStu = (apartmentList?.data || [])
        .filter(item =>
            ["Approved By Manager", "Accepted By Apartment", "Created"].includes(item?.terms_status)
        )
        .map(item => ({
            id: item?.id,
            label: item?.apartment_name,
            value: item?.apartment_name,
        }));

    const validationSchema = yup.object().shape({
        firstname: yup.string().required("Parent's name is required"),
        lastname: yup.string().required("Student's name is required"),
        mobile: yup.string().test("is-phone", "Invalid phone number", function (value) {
            return value ? isValidPhoneNumber(value) : false;
        }),
        apartment_name: yup.string().required("Apartment name is required"),
        email: yup
            .string()
            .email("Invalid email format")
            .required("Email is required")
    });

    const initialValues = {
        firstname: "",
        lastname: "",
        email: "",
        mobile: "",
        apartment_name: "",
        otp: ""
    };

    const { showToaster } = useToaster();


    const sendOtpMutation = useMutation({
        mutationFn: (formData) => api.post("send-otp", formData),
    });
    const handleCheckOtp = (value) => {
        sendOtpMutation.mutate({ mobile: value }, {
            onSuccess: (response) => {
                if (response?.data?.message) {
                    setIsOtpSent(true)
                }
            },
            onError: (error) => {
                showToaster(error?.data?.message, 'Error', 'error')
            },
        });
    }

    const sendMutation = useMutation({
        mutationFn: (formData) => api.post("verify-otp-register ", formData),
    });
    const handleSubmit = (values, { resetForm }) => {
        sendMutation.mutate(values, {
            onSuccess: (response) => {
                showToaster("Student Added successfully", 'Success', 'success')
                setIsOtpSent(false)
                resetForm()
            },
            onError: (error) => {
                showToaster(error?.response?.data?.message, 'Error', 'error')
            },
        });
    };

    return (
        <NormalContainerWithHeader headerText={"Register Student"}>
            <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
                {({ resetForm }) => (
                    <Form>
                        <Grid2 container spacing={3} >
                            <Grid2 children size={{ sm: 6, md: 4, xs: 12 }}>
                                <Field
                                    name="firstname"
                                    component={TextFormField}
                                    label="Parent's Name"
                                    isRequired={true}
                                />
                            </Grid2>
                            <Grid2 children size={{ sm: 6, md: 4, xs: 12 }}>
                                <Field
                                    name="lastname"
                                    component={TextFormField}
                                    label="Student's Name"
                                    isRequired={false}
                                />
                            </Grid2>

                            <Grid2 children size={{ sm: 6, md: 4, xs: 12 }}>
                                <Field
                                    name="email"
                                    component={TextFormField}
                                    label="Email"
                                    isRequired={false}
                                />
                            </Grid2>
                            <Grid2 children size={{ sm: 6, md: 4, xs: 12 }}>
                                <Field
                                    name="apartment_name"
                                    component={AutoCompleteField}
                                    options={ApartmentOptionsStu}
                                    label="Apartment Name"
                                    isRequired={true}
                                    isLoading={isLoadingApartmentList}
                                />
                            </Grid2>
                            <Grid2 children size={{ sm: 6, md: 4, xs: 12 }}>
                                <Field name="mobile">
                                    {({ field, form }) => (
                                        <PhoneInputFormField
                                            field={field}
                                            form={form}
                                            label="Mobile"
                                            isRequired={true}
                                            disabled={isOtpSent}
                                            endIcon={<CheckIcon />}
                                            OnButtonClick={async () => {
                                                await form.validateField("mobile");
                                                const error = form.errors?.mobile;

                                                if (!error) {
                                                    handleCheckOtp(field.value);
                                                } else {
                                                    form.setFieldTouched("mobile", true, true); // show error
                                                }
                                            }}
                                        />
                                    )}
                                </Field>

                                {
                                    isOtpSent && <Typography variant="h6" color="grey">
                                        Otp has Sent
                                    </Typography>
                                }
                            </Grid2>
                            {isOtpSent && <Grid2 children size={{ sm: 6, md: 4, xs: 12 }}>
                                <Field
                                    name="otp"
                                    component={TextFormField}
                                    label="Add Otp"
                                    isRequired={true}
                                />
                            </Grid2>}


                        </Grid2>
                        <CustomDivider />
                        <Grid2 container spacing={Grid_Gap} sx={{ justifyContent: "end" }}>
                            <Grid2 children size={{ xs: 12, sm: 3 }}>
                                <Button variant='outlined' fullWidth onClick={resetForm}>Cancel</Button>
                            </Grid2>
                            <Grid2 children size={{ xs: 12, sm: 3 }}>
                                <Button variant='contained' type="submit" fullWidth>
                                    Register

                                </Button>
                            </Grid2>
                        </Grid2>
                    </Form>
                )}
            </Formik>
        </NormalContainerWithHeader>
    )
}

export default RegisterStudent